// La nouvelle interface, épurée (10 octobre 2026) : Polis, l'onglet
// Projections. « Fermer » et « Chargement… » restent lus dans `projector.commun`.
export default {
  erreurLecture: 'Lecture de la projection impossible',
  erreurLancement: 'La vague n’a pas pu partir',
  // Le Sonar de l'élection (11 octobre 2026) : un lien discret par liste ou candidat.
  interroger: 'Interroger ses électeurs',
  vague: {
    libelle: 'Vague',
    option: '{jour} · {libelle}',
    optionHeure: '{base}, {heure}',
    enCours: '{vague} · en cours',
  },
  lancer: {
    bouton: 'Lancer une vague',
    question: 'Lancer une vague maintenant ?',
    // Le dernier point sur les candidatures a plus de 24 heures (21 octobre 2026).
    questionPoint: 'Lancer une vague maintenant ? Orion refera d’abord le point sur les candidatures.',
    confirmer: 'Lancer',
    annuler: 'Annuler',
  },
  // Le point sur les candidatures avant une vague (21 octobre 2026).
  point: {
    enCours: 'Orion fait le point sur les candidatures…',
    echec: 'Le point sur les candidatures n’a pas abouti : {raison}. Lancer la vague quand même ?',
    quandMeme: 'Lancer quand même',
    tropLong: 'il n’est pas revenu dans les vingt minutes',
    sansRaison: 'raison inconnue',
  },
  // Le scellement de la vague affichée (21 octobre 2026), près du sélecteur de vague.
  scellement: {
    scellee: 'Scellée le {jour} à {heure}',
    essai: 'Essai scellé le {jour} à {heure}',
    heure: '{h} h {m}',
    verifier: 'Vérifier',
    verifierAria: 'Vérifier ce scellement dans le registre',
  },
  vide: {
    titre: 'Aucune vague rendue pour cette élection',
    texte: 'La projection s’affiche ici dès qu’une vague est rendue.',
    enCours: 'Une vague est en cours : sa projection s’affichera ici dès qu’elle sera rendue.',
  },
  verdict: {
    majorite: '{bloc} atteindrait la majorité avec {n} sièges.',
    aucunBloc: 'Aucun bloc n’atteint {majorite} sièges : {premier} en compterait {n}{suite}.',
    listeMajorite: '{liste} atteindrait la majorité avec {n} sièges.',
    aucuneListe: 'Aucune liste n’atteint {majorite} sièges : {premier} en compterait {n}{suite}.',
    suite: ', {nom} {n}',
    leBloc: 'le bloc {nom}',
    leBlocNomme: 'le {nom}',
    presqueSur: '{a} est au second tour dans presque tous les cas.',
    gagne: '{a} l’emporte dans {pa} des cas.',
    gagne2: '{a} l’emporte dans {pa} des cas, {b} dans {pb}.',
    gagnePluriel: '{a} l’emportent dans {pa} des cas.',
    gagne2Pluriel: '{a} l’emportent dans {pa} des cas, {b} dans {pb}.',
    adversaires: 'Son adversaire se joue entre {b} et {c}, avec {pb} et {pc} % de chances.',
    adversaire: 'Son adversaire serait {b}, avec {pb} % de chances.',
    ouvert3: 'Le second tour se joue entre {a} ({pa}), {b} ({pb}) et {c} ({pc}).',
    ouvert2: 'Le second tour se joue entre {a} ({pa}) et {b} ({pb}).',
    enTete: 'En tête du premier tour : {listes}.',
    candidat: '{nom} ({pct})',
  },
  sousVerdict: {
    sondages: 'Projection du {jour}, encadrée par les {n} sondages publiés du {du} au {au}',
    unSondage: 'Projection du {jour}, encadrée par le seul sondage publié du {du} au {au}',
    sansSondage: 'Projection du {jour}, sans sondage publié dans les trente jours qui la précèdent',
    loinDuVote: '{texte} · à {mois} mois du vote, les fourchettes restent larges',
  },
  hemicycle: {
    titre: 'L’hémicycle projeté',
    aria: 'L’hémicycle projeté : {total} sièges, la majorité à {majorite}',
    legende: 'Les sièges de chaque liste',
  },
  blocs: {
    titre: 'Les blocs',
    fourchette: '{bas} ~ {haut} sièges',
    jumeaux: 'Jumeaux : {n} sièges',
    chanceJumeaux: '{pct} de chances d’atteindre {majorite} selon les jumeaux',
    sondages: 'sondages {n}',
    chance: '{pct} de chances d’atteindre {majorite}',
    loin: 'loin de {majorite}',
    trait: 'Le trait pointillé marque les {majorite} sièges de la majorité',
  },
  listes: {
    titre: 'Les listes',
    legende: 'en sièges · la barre montre la fourchette, le trait la moyenne des sondages',
    legendeSansSondages: 'en sièges · la barre montre la fourchette',
    liste: 'Liste',
    voix: 'Voix',
    projection: 'Projection',
    fourchette: 'Fourchette',
    sondages: 'Sondages',
    ecart: 'Écart',
    aucune: 'Aucune liste n’obtient de siège à cette vague.',
  },
  seuil: {
    titre: 'Autour du seuil',
    legende: 'la chance de passer le seuil, et donc d’avoir des élus',
    legendeSansChance: 'sans élu à cette vague',
  },
  premierTour: {
    titre: 'Le premier tour',
    titreUnTour: 'Le vote',
    gagne: 'Chance de l’emporter',
    legende: 'la barre montre la fourchette, le trait la moyenne des sondages',
    legendeSansSondages: 'la barre montre la fourchette',
    candidat: 'Candidat',
    fourchette: 'Fourchette',
    projection: 'Projection',
    projectionSondages: 'Projection des sondages',
    qualifie: 'au second tour',
    autres: 'Voir les {n} autres candidats',
    replier: 'Ne garder que le second tour',
    projectionJumeaux: 'Projection des jumeaux',
    deuxProjections: 'La projection des sondages dit ce que les sondages publieront ; celle des jumeaux, ce que pense l’électorat qu’ils forment, sans les sondages.',
    legendeJumeaux: 'la barre montre la fourchette des sondages projetés, le trait leur moyenne, le rond la projection des jumeaux',
    fourchetteJumeaux: 'jumeaux {f}',
    voixCourt: '{n} M de voix',
    second: 'Au second tour',
    sondages: 'sondages {n}',
    voix: '{n} M de voix',
    possible: 'candidature possible, {p}',
    bulletin: 'déclarée, sur le bulletin à {p}',
    // La projection centrale (21 octobre 2026) : le scénario le plus probable selon les jumeaux, celui de l'onglet Scénarios.
    projectionCentrale: 'Projection centrale',
    // La projection des déclarés (21 octobre 2026) : les seuls candidats officiellement déclarés.
    projectionDeclares: 'Projection des déclarés',
    // Étroit, trois colonnes de nombres ou plus : leurs noms courts. Ce sont aussi ceux du sélecteur.
    court: {
      sondages: 'Sondages',
      jumeaux: 'Jumeaux',
      centrale: 'Centrale',
      declares: 'Déclarés',
    },
    enumeration: '{debut} et {fin}',
    // Une projection seule : le rang de chaque candidat, dit au lecteur d'écran.
    rang: 'Rang',
  },
  // Le sélecteur au-dessus du premier tour (21 octobre 2026) : toutes les projections, ou une seule.
  vues: {
    aria: 'Projection affichée',
    tout: 'Tout',
  },
  centrale: {
    sans: 'Projection centrale : sans {noms}, qui ne se présenteraient probablement pas.',
    sansUn: 'Projection centrale : sans {noms}, qui ne se présenterait probablement pas.',
    absent: 'ne se présenterait probablement pas',
    aMesurer: 'se mesurera à la prochaine vague',
  },
  declares: {
    sans: 'Projection des déclarés : sans {noms}, dont les candidatures ne sont pas déclarées.',
    sansUn: 'Projection des déclarés : sans {noms}, dont la candidature n’est pas déclarée.',
    absent: 'candidature pas déclarée',
  },
  // Ce que montre la vue choisie, sous le titre du premier tour (21 octobre 2026) : jamais comment Orion la calcule.
  explication: {
    tout: 'La barre montre la fourchette des sondages projetés, le trait leur moyenne, le rond la projection des jumeaux ; le second tour, selon les jumeaux. La colonne encadrée est la projection centrale.',
    sondages: 'Ce que diraient les sondages, selon Orion. La barre montre la fourchette, le trait la moyenne des sondages déjà publiés.',
    jumeaux: 'Ce que voteraient les jumeaux d’Orion.',
    jumeauxTous: 'Ce que voteraient les jumeaux d’Orion si tous les candidats possibles se présentaient.',
    centrale: 'Ce que voteraient les jumeaux si seuls les candidats probables se présentaient : le scénario le plus probable.',
    declares: 'Ce que voteraient les jumeaux si seuls les candidats officiellement déclarés se présentaient.',
  },
  participation: {
    ligne: 'Participation projetée : {taux} ({fourchette})',
    exprimes: 'soit {n} millions de suffrages exprimés sur {inscrits} millions d’inscrits',
    parVague: 'Vague par vague',
    masquer: 'Masquer',
  },
  duels: {
    titre: 'Les seconds tours probables',
    legende: 'la part des scénarios où ce duel a lieu',
    legendeJumeaux: 'selon les jumeaux : la part des scénarios où ce duel a lieu, et ce qu’ils y voteraient, parmi les suffrages exprimés',
    face: '{a} face à {b}',
    mesure: '{a} {pa} · {b} {pb}',
    gagne: '{nom} l’emporte dans {p} des cas',
  },
  vainqueur: {
    titre: 'Le vainqueur probable',
    chance: '{p} des cas',
    autre: '{nom} {p}',
    nonMesure: 'seconds tours non mesurés : {p}',
  },
  camps: {
    titre: 'Les camps',
    aria: 'La part de chaque camp au premier tour',
    sondages: 'sondages {n}',
  },
  unites: {
    pct: '{n} %',
    fourchette: '{bas} ~ {haut}',
    fourchettePct: '{bas} % ~ {haut} %',
    moinsDeUn: '< 1',
  },
}
